import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var list_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(Path, { d: "M4 4v1.5h16V4H4zm8 8.5h8V11h-8v1.5zM4 20h16v-1.5H4V20zm4-8c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z" }) });
export {
  list_default as default
};
//# sourceMappingURL=list.js.map
